import { useLoading } from "../../contexts/LoadingContext";
import "./loader.css";

export default function Loader() {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="loading-container">
      <img
        src={"/images/loadingLogo.png"}
        alt="Загрузка…"
        className="loading-logo"
      />
    </div>
  );
}
